
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";

@Component
export default class MyPagination extends Vue {

  @Prop({ type: Number, default: 0 }) pageIndex;
  @Prop({ type: Number, default: 10 }) pageSize;
  @Prop({ type: Array, default: ()=>[10, 50, 100, 500] }) pageSizes;
  @Prop({ type: Number, default: 1 }) total;

  pageIdx: number = 1;
  pageSizer: number = 10;
  mounted(){
    this.pageIdx= this.pageIndex;
    this.pageSizer= this.pageSize
  }
  @Emit("currentChange") triggerCurrentChange(val) {
    
  }

  @Emit("sizeChange") currentSizeChange(val: number) {
   
  }
  @Watch("pageIndex") watchPageIndex(newVal) {
    this.pageIdx = newVal;
  }
  @Watch("pageSize") watchPageSize(newVal) {
    this.pageSizer = newVal;
  }
}
